export const AUTHORIZE_REQUEST = 'AUTHORIZE_REQUEST'
export const AUTHORIZE_SUCCESS = 'AUTHORIZE_SUCCESS'
export const AUTHORIZE_FAILURE = 'AUTHORIZE_FAILURE'

export const USER_SIGN_OUT_FAILURE = 'USER_SIGN_OUT_FAILURE'
export const USER_SIGN_OUT_SUCCESS = 'USER_SIGN_OUT_SUCCESS'

export const GET_USER_REQUEST = 'GET_USER_REQUEST'
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS'
export const GET_USER_FAILURE = 'GET_USER_FAILURE'

export const GET_USER_REFERRALS_REQUEST = 'GET_USER_REFERRALS_REQUEST';
export const GET_USER_REFERRALS_SUCCESS = 'GET_USER_REFERRALS_SUCCESS';
export const GET_USER_REFERRALS_FAILURE = 'GET_USER_REFERRALS_FAILURE';


export const GET_PERSONAL_INFO_REQUEST = 'GET_PERSONAL_INFO_REQUEST';
export const GET_PERSONAL_INFO_SUCCESS = 'GET_PERSONAL_INFO_SUCCESS';
export const GET_PERSONAL_INFO_FAILURE = 'GET_PERSONAL_INFO_FAILURE';

export const SEND_CONFIRM_EMAIL_LINK_REQUEST = 'SEND_CONFIRM_EMAIL_LINK_REQUEST';
export const SEND_CONFIRM_EMAIL_LINK_SUCCESS = 'SEND_CONFIRM_EMAIL_LINK_SUCCESS';
export const SEND_CONFIRM_EMAIL_LINK_FAILURE = 'SEND_CONFIRM_EMAIL_LINK_FAILURE';

export const USER_UPDATE_PERSONAL_INFO_REQUEST = "USER_UPDATE_PERSONAL_INFO_REQUEST";
export const USER_UPDATE_PERSONAL_INFO_SUCCESS = "USER_UPDATE_PERSONAL_INFO_SUCCESS";
export const USER_UPDATE_PERSONAL_INFO_FAILURE = "USER_UPDATE_PERSONAL_INFO_FAILURE";

export const USER_CONFIRM_EMAIL_ACTION_REQUEST = "USER_CONFIRM_EMAIL_ACTION_REQUEST";
export const USER_CONFIRM_EMAIL_ACTION_SUCCESS = "USER_CONFIRM_EMAIL_ACTION_SUCCESS";
export const USER_CONFIRM_EMAIL_ACTION_FAILURE = "USER_CONFIRM_EMAIL_ACTION_FAILURE";

export const DELETE_AUTH_DATA_SUCCESS = 'DELETE_AUTH_DATA_SUCCESS'
export const END_TIMER = 'END_TIMER'
export const CLEAR_PERSONAL = 'CLEAR_PERSONAL'